/**
 * getQueryParams
 *
 * Parses the querysstring (location.search) and returns an object of key: value
 *
 */
export function getQueryParams<Params>(querystring = getLocationSearch()) {
  const urlParams = new URLSearchParams(querystring);

  return Array.from(urlParams.entries()).reduce(function (acc, [key, value]) {
    // sorry,k gross type dance
    acc[key as keyof Params] = value;
    return acc;
  }, {} as Record<keyof Params, string>);
}

function getLocationSearch() {
  if (typeof window === "undefined") return "";
  return window.location.search;
}
